import { NETWORK_ONLINE, NETWORK_OFFLINE } from '../actions/actionTypes';

export default function networkReducer(state = { isOnline: true }, action) {
  switch (action.type) {
    case NETWORK_ONLINE:
      return { isOnline: true };
    case NETWORK_OFFLINE:
      return { isOnline: false };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/network.js